import CryptoJS from "crypto-js";

function generate(id, key, secret, url) {
  const payload = id + ":" + url + ":" + key;
  return CryptoJS.HmacSHA256(payload, secret).toString(CryptoJS.enc.Hex);
}

export { generate };
